import React, { Component } from 'react'

class DirectSearch extends Component {
  constructor (props) {
    super(props)

    this.state = {
      courseID: '',
      courseLink: '',
      infoMessage: ''
    }

    this.onChange = this.onChange.bind(this)
    this.onClick = this.onClick.bind(this)
    this.filterCourse = this.filterCourse.bind(this)
    this.filterDate = this.filterDate.bind(this)
  }

  onChange (e) {
    this.setState({ courseID: e.target.value })
  }

  onClick (e) {
    e.preventDefault()
    let filteredNumbers = this.props.courses.filter(this.filterCourse)
    if (filteredNumbers.length > 0) {
      this.setState({ infoMessage: '' })
      window.location = filteredNumbers[0].detail
    } else {
      this.setState({ infoMessage: 'Keine übereinstimmende Kursnummer gefunden.' })
    }
  }

  filterCourse (item) {
    if (item.termine.filter(this.filterDate).length > 0) {
      return true
    }
    return false
  }

  filterDate (item) {
    let thisCourseID = this.state.courseID
    let thisCourseIDStar = thisCourseID + '*'
    if (item.cid === thisCourseID || item.cid === thisCourseIDStar) {
      return true
    }
    return false
  }

  render () {
    let infoIcon
    if (this.state.infoMessage.length > 0) {
      infoIcon = <i className='fas fa-exclamation-circle' />
    }
    return (
      <div className='filter-bar narrow'>
        <div className='filter-row'>
          <div className='flex'>
            <input type='text' name='courseid' placeholder='Kursnummer' value={this.state.courseID} onChange={this.onChange} />
            <a className='btn btn-outline-primary' href='#' onClick={this.onClick}>Gehe zu Kurs <i className='fa fa-angle-right' /></a>
          </div>
          <span className='message'>{infoIcon}{this.state.infoMessage}</span>
        </div>
      </div>
    )
  }
}

export default DirectSearch
